import { useContext, useEffect, useState } from 'react';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import useService from './useService';

const useForm60Details = () => {
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [form60IsCollapsed, setForm60IsCollapsed] = useState<boolean>(true);
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [form60Data, setForm60Data] = useState<any>([]);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);
	const { getForm60Details, submitForm60Details } = useService();

	const fetchRowData = async () => {
		try {
			setShowLoader(true);
			const fetchedData = await getForm60Details();
			setForm60Data({ rowCount: fetchedData.rowCount, data: fetchedData.data });
		} catch (error: any) {
			showAlert(_get(error, 'error', 'Error while fetching data'), { type: 'error' });
		} finally {
			setShowLoader(false);
			setDataFetchComplete(true);
		}
	};

	useEffect(() => {
		if (!form60IsCollapsed && !dataFetchComplete) {
			fetchRowData();
		}
	}, [form60IsCollapsed]);

	const handleDatalistFetchData = () => {
		return form60Data;
	};

	const turnForceUpdateOff = () => {
		setForceUpdate(false);
	};

	const turnForceUpdateOn = async () => {
		if (!form60IsCollapsed) {
			await fetchRowData();
			setForceUpdate(true);
		}
	};

	return {
		form60IsCollapsed,
		setForm60IsCollapsed,
		showLoader,
		handleDatalistFetchData,
		turnForceUpdateOn,
		turnForceUpdateOff,
		forceUpdate,
		submitForm60Details,
		dataFetchComplete
	};
};

export default useForm60Details;
